import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import WineNameList from './WineNameList';
import WineNameForm from './WineNameForm';

const WineNameRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<WineNameList />} />
      <Route path="/create" element={<WineNameForm />} />
      <Route path="/edit/:id" element={<WineNameForm />} />
      <Route path="*" element={<Navigate to="/admin/wine-names" replace />} />
    </Routes>
  );
};

export default WineNameRoutes;
